<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="p-3">
            <b-row class="mb-3 customer-search">
            <b-col
            lg="6"
            md="6"
            sm="6"
            xs="12"
            class="search-field mt-0"
          >
             
          </b-col>
            <b-col sm="12" class="page-block mx-3">
                <strong>
                    {{ $translate("page") }}: {{ pagination.page }}
                    {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                    {{ pagination.total }}
                </strong>
            </b-col>
            </b-row>
            <b-card-header class="assets-filter">
                <b-row class="mt-3">
                    <b-col cols="12" md="12">
                        <div class="d-flex">
                            <b-button variant="blue-button" id="order-transaction-filter-btn" class="me-2"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button id="order-transaction-reset-filter-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                            <b-button id="order-transaction-export-data-btn" variant="blue-button" @click="exportData" v-b-tooltip.hover
                            :title="$translate('export_data')" class="mx-2 float-right">
                            Excel
                        </b-button>
                        </div>
                    </b-col>
                    <!-- <b-col cols="12" md="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col> -->
                </b-row>
                <order-transaction-filters v-show="toggle_filters"  :order-types="orderTypes" v-model="filters" />
            </b-card-header>
            <b-card-body>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filters" show-empty id="order-transactions-table">
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(reference_no)="{ item }">
                          
                            <span class="tooltip-pointer">
                                <span
                                  @mouseover="showTooltip = item.id"
                                  @mouseleave="showTooltip = false"
                                  v-b-tooltip.hover
                                >
                                <b-link :to="`/ams/activities/${item.id}`">
                                    {{ item.reference_no }}</b-link>
                                </span>
                                <span v-if="showTooltip === item.id">
                                  <div
                                    v-html="getTooltipContent(item)"
                                    class="customer-tooltip"
                                  ></div>
                                </span>
                              </span>
                        </template>
                        <template #cell(id)="{ item }">
                            <h6>
                            <b-badge :variant="item | filterStatusVariant">{{
                                filterStatusName(item)
                            }}</b-badge>
                            </h6>
                        </template>
                    
                        <template #empty>
                            <div class="text-center">No Data Available</div>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination
                            class="justify-content-center mt-4"
                            v-model="pagination.page"
                            :total-rows="pagination.total"
                            :per-page="pagination.pageSize"
                            aria-controls="customerTable"
                            :prev-text="$translate('previous')"
                            :next-text="$translate('next')"
                            pills
                            align="center"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
//import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import addActivityTypeIcon from '@/assets/images/icon/blue-add.svg'
import permissionsMixins from '@/mixins/permissionsMixins'
import dateTimeMixins from '@/mixins/dateTimeMixins'

import OrderTransactionFilters from './OrderTransactionFilters.vue'

/* const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
}) */

export default {
    name: 'Payments-OrderTransactions',
    mixins: [popupMixins, permissionsMixins, dateTimeMixins],
    props: ['type', 'title'],
    components: { OrderTransactionFilters },

    data() {
        return {
            showTooltip: false,
            query: "",
            toggle_filters: false,
            filters: {
                order_search: "",
                customer_id: null,
                completedFromDate: null,
                completedToDate: null,
                dueFromDate: null,
                dueToDate: null,
                outstanding_balance: null,
                quantityType: 3,
            },
            icon: addActivityTypeIcon,
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
          
        }
    },
    mounted() {
        const { query } = this.$route;
        if (query.query) this.query = query.query;

        if (query.order_search)
            this.$set(this.filters, "order_search", query.order_search);

        this.doSearch(true)
    },
    filters: {
        formatPrice: function (value) {
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        capitalize: function (value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },

        filterStatusVariant(item) {
            return item.completed ? "success" : item.released ? "primary" : "danger";
        },
    },
    watch: {
        items: {
            handler: function () {
                // this.tableLoading = false
            },
            deep: true,
        },

        filters: {
            handler: function () {
                this.doSearch(true)
            },
            deep: true,
        },

        "pagination.page": function () {
            this.doSearch();
        },
    },

    computed: {
        fields() {
            return [
                { key: 'reference_no', label: this.$translate('reference_no'),sortable: true },
                {
                    key: 'total_balance',
                    label: this.$translate('total_balance'),
                    sortable: true
                },
                // {
                //     key: 'original_activity',
                //     label: this.$translate('original_activity'),
                //     formatter: (value, key, item) => (item.activity_link_list?.original_activity?.reference_no),
                //     thStyle: { width: "9%" },
                // },
                // {
                //     key: 'previous_activity',
                //     label: this.$translate('previous_activity'),
                //     formatter: (value, key, item) =>value && (item.activity_link_list?.previous_activity?.reference_no),
                //     thStyle: { width: "9%" },
                // },
                {
                    key: 'type',
                    label: this.$translate('activity_type'),
                    formatter: (value, key, item) => item?.type?.name,
                    sortable: true 
                },
                // {
                //     key: 'description',
                //     label: this.$translate('description'),
                //     thStyle: { width: "20%", whiteSpace: "normal" },
                //     thClass: "order-table-description",
                //     tdClass: "order-table-description",
                // },
                // {
                //     key: 'allow_payment',
                //     label: this.$translate('payment_allowed'),
                //     formatter: (value, key, item) => (item?.type?.allow_payment) ? "Yes": "No" 
                // },

                // {
                //     key: 'schedule_at',
                //     label: this.$translate('due'),
                //     formatter: (value) => displayLocalDate(value),
                // },

                // {
                //     key: 'created_at',
                //     label: this.$translate('created_on'),
                //     formatter: (value) => displayLocalDate(value),
                // },

                // {
                //     key: "completed_by",
                //     label: this.$translate("completed_by"),
                //     formatter: (value) => value? `${value?.first_name} ${value?.last_name}`: ''
                // },

                // {
                //     key: "completed_at",
                //     label: this.$translate("completed_date"),
                //     formatter: (value) => displayLocalDate(value),
                // },
                {
                    key: "id",
                    label: this.$translate("status"),
                    sortable: true
                },
                {
                    key: 'customer_code',
                    label: this.$translate('customer_code'),
                    formatter: (value, key, item) => item?.customer?.code,
                    sortable: true 
                },
                {
                    key: 'customer',
                    label: this.$translate('customer_name'),
                    formatter: (value, key, item) => item?.customer?.name,
                    sortable: true 
                },
                {
                    key: 'total_price',
                    label: this.$translate('total'),
                    sortable: true
                },
                {
                    key: 'total_discount',
                    label: this.$translate('total_discount'),
                    thStyle: { whiteSpace: "normal" },
                    sortable: true
                },
                {
                    key: 'total_tax',
                    label: this.$translate('total_tax'),
                    sortable: true
                },
                {
                    key: 'grand_total',
                    label: this.$translate('grand_total'),
                    sortable: true
                },
                {
                    key: 'total_payments_and_credits',
                    label: this.$translate('total_paid'),
                    sortable: true
                },
               
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },
        items() {
            // console.log('this is getting computed-', this.$store.state.payments.items)
            const items = this.$store.state.payments.transaction_items
            console.log('items', items)
            return items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.payments.transaction_items_pagination || { page: 1 };
        },
        orderTypes() {
        return this.$store.getters["orderType/activityTypesByPermission"];
        },
    },

    methods: {
        resetFilters() {
            this.filters = {
                order_search: "",
                customer_id: null,
                completedFromDate: null,
                completedToDate: null,
                dueFromDate: null,
                dueToDate: null,
                outstanding_balance: null,
                quantityType: 3,
            }
            this.doSearch()
        },
        async doSearch(isforcedReload = false) {

            let {
                query,
                pagination: { page },
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            page = parseInt(page) || 1;
            
            this.tableLoading = true;
            let type = "";
            if (filters.type && filters.type.length > 0){
            type = (filters.type.map(i => i.id)).join(',')
            }
            try{
                await this.$store.dispatch('payments/fetchActivityTransactions', {
                    query,
                    filters: {...filters, type: type},
                    page,
                    isforcedReload,
                    type
                })
            } catch(err) {
                console.log('fetchActivityTransactions Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        async exportData() {
         console.log('callled');
         
            let {
                query,
                filters
            } = this
            
            if(filters.order_search !="" && filters.order_search.length < 3) return;
            
            this.tableLoading = true
            await  this.$store.dispatch('payments/exportExcelOrderTransaction', {
                query,
                filters,
            })
            this.tableLoading = false
        },
        filterStatusName(item) {
            return item.completed
                ? this.$translate("completed")
                : item.released
                ? this.$translate("processing")
                : this.$translate("pending");
        },

        getTooltipContent(item) {
            let { displayLocalDate } = this;
            let payment_allowed = (item?.type?.allow_payment) ? "Yes" : "No";
            let htmlContent = `<ul>
                <li>${this.$translate("original_activity")}: ${item.activity_link_list?.original_activity?.reference_no || '-'}</li>
                <li>${this.$translate("previous_activity")}: ${item.activity_link_list?.previous_activity?.reference_no || '-'}</li>
                <li>${this.$translate("description")}: ${item.description || '-'}</li>
                <li>${this.$translate("payment_allowed")}: ${payment_allowed}</li>
                <li>${this.$translate("Due")}: ${displayLocalDate(item.schedule_at) || '-'}</li>
                <li>${this.$translate("created_on")}: ${displayLocalDate(item.created_at) || '-'}</li>
                <li>${this.$translate("completed_by")}: ${item.completed_by || '-'}</li>
                <li>${this.$translate("date_completed")}: ${displayLocalDate(item.completed_at) || '-'}</li>
            </ul>`;
            return htmlContent;
     }

    },
}
</script>
<style >
.order-table-description{
    max-width:260px !important;
    width:260px !important;
}
.float-right{
    float:right !important;
}
#order-transactions-table td[aria-colindex="5"]{
    white-space: wrap;
    max-width: 265px;
}
</style>
